module.exports = __webpack_public_path__ + "img/xls.31849125.svg";